import { USER_UPDATE_INFO, USER_UPDATE_EVALUATION, USER_EXAM_LIST } from '@/store/mutations'

import {
	USER_LOGIN,
	USER_LOGOUT,
	PHONE_LOGIN,
	WECHAT_LOGIN,
	USER_EVALUATION,
	USER_EXAM_LIST_UPDATE
} from '@/store/actions'

import ApiClient from '@midipro/js-api'

import { Message } from 'element-ui'
import router from '../../routes'

var api = new ApiClient({
	handlers: {
		onErrorPrompt(message) {
			Message({
				message,
				type: 'error',
				duration: 5000
			})
		}
	}
})

const user = {
	state: {
		userInfo: null, // 用户信息
		evaluation: null, //答卷
		examList: [] // 评测活动列表
	},

	mutations: {
		removeUserInfo: (state) => {
			state.userInfo = null
		},
		[USER_UPDATE_INFO]: (state, userInfo) => {
			state.userInfo = userInfo
		},
		[USER_EVALUATION]: (state, eva) => {
			state.evaluation = eva
		},
		[USER_EXAM_LIST]: (state, examList) => {
			state.examList = examList
		},
		[USER_UPDATE_EVALUATION]: (state, type) => {
			// state.evaluation[type].end_answer = true;
		}
	},

	actions: {
		async [USER_LOGIN]({ commit }, form) {
			const VERSION_2 = 1
			let res = await api.account.login(form.username, form.password, VERSION_2, '', form)
			commit(USER_UPDATE_INFO, res)
			commit('persist')
		},
		async [PHONE_LOGIN]({ commit }, form) {
			let res = await api.account.PhoneLogin(form.Phone, form.Code, { from: form.from })
			commit(USER_UPDATE_INFO, res)
			commit('persist')
		},

		//微信登录
		async [WECHAT_LOGIN]({ commit }, code, state) {
			let res = await api.account.wechatLogin(code, state)
			commit(USER_UPDATE_INFO, res)
			commit('persist')
			router.push('/workbench/classgrade_mgn')
		},

		async [USER_LOGOUT]({ commit }) {
			await api.account.logout()
			commit(USER_UPDATE_INFO, null)
			commit(USER_EVALUATION, null)
			commit('persist')
		},
		[USER_EXAM_LIST_UPDATE]({ commit }, examList) {
			commit(USER_EXAM_LIST, examList)
			commit('persist')
		},
		[USER_EVALUATION]({ commit }, val) {
			commit(USER_EVALUATION, val)
			commit('persist')
		}
	}
}

export default user
export { api }
